import { Button, Snackbar } from "@mui/material";
import Alert from "@mui/material/Alert";
import { makeStyles } from "@mui/styles";
import React, { useEffect, useRef, useState } from "react";
import "../App.css";
import { getExpiresInTimeFromCookie, getTimeUntilCookieExpires, logout } from "../util/authentication";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "348px",
    maxWidth: "95%",
    margin: "auto",
    "& > * + *": {
      marginTop: theme.spacing(2),
    },
  },
  warning: {
    backgroundColor: theme.palette.primary.swaYellow,
    color: theme.palette.secondary.swaBlack,
  },
}));

const UserSessionTimeoutSnackbar = () => {
  const [timeoutCountdown, setTimeoutCountdown] = useState(null);
  const [isLessThanTenMinutesLeft, setIsLessThanTenMinutesLeft] = useState(false);
  const [isSnackbarClosed, setIsSnackbarClosed] = useState(false);
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const expiresInRef = useRef(null);
  const classes = useStyles();

  useEffect(() => {
    if (!isLoggingOut) {
      if (!expiresInRef.current) {
        expiresInRef.current = getExpiresInTimeFromCookie();
      }
      const timer = setTimeout(() => {
        const timeUntilCookieExpires = getTimeUntilCookieExpires(expiresInRef.current);
        setTimeoutCountdown(timeUntilCookieExpires);
        if (
          timeUntilCookieExpires === null ||
          (timeUntilCookieExpires.hours <= 0 &&
            timeUntilCookieExpires.minutes <= 0 &&
            timeUntilCookieExpires.seconds <= 0)
        ) {
          logOut();
          return () => clearTimeout(timer);
        }
        if (calculateIfCookieExpiresInLessThanTenMinutes(timeUntilCookieExpires)) {
          setIsLessThanTenMinutesLeft(true);
        }
      }, 1000);
      return () => clearTimeout(timer);
    }
  });

  const calculateIfCookieExpiresInLessThanTenMinutes = (timeUntilCookieExpires) => {
    if (timeUntilCookieExpires.hours === 0) {
      if (
        timeUntilCookieExpires.minutes === process.env.REACT_APP_PING_SESSION_TIMEOUT_WARNING_MINUTES_REMAINING &&
        timeUntilCookieExpires.seconds === 0
      ) {
        return true;
      }
      if (timeUntilCookieExpires.minutes < process.env.REACT_APP_PING_SESSION_TIMEOUT_WARNING_MINUTES_REMAINING) {
        return true;
      }
    }
    return false;
  };

  const logOut = () => {
    setIsLoggingOut(true);
    logout();
  };

  const handleYes = () => {
    logOut();
  };

  const handleClose = (event, reason) => {
    if (reason !== "clickaway") {
      setIsSnackbarClosed(true);
    }
  };

  if (isLessThanTenMinutesLeft) {
    return (
      <Snackbar
        className="session-snackbar"
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={!isSnackbarClosed}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          variant="filled"
          severity="warning"
          sx={{ width: "100%" }}
          className={classes.warning}
        >
          You have{" "}
          <strong>
            {timeoutCountdown !== null ? timeoutCountdown.minutes : "0"}:
            {timeoutCountdown !== null ? timeoutCountdown.seconds.toString().padStart(2, "0") : "00"}
          </strong>{" "}
          minutes until your STARS session expires. Would you like to log out now?
          <Button className="alert-button" variant="contained" color="primary" size="small" onClick={handleYes}>
            YES
          </Button>
        </Alert>
      </Snackbar>
    );
  }
  return "";
};

export default UserSessionTimeoutSnackbar;
